import angular from "angular";

angular
    .module('app')
    .component('rolesControl', {
        template: require('./roles-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            roles: '<',
            permissions: '<',
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.openRoleForm = function (role) {
        $uibModal
            .open({
                component: 'roleForm',
                resolve: {
                    role: function () {
                        return role;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (role) {
                        role.name = result.name;
                        role.label = result.label;
                    } else {
                        result.users = [];
                        result.permissions = [];
                        $ctrl.roles.push(result);
                    }
                }
            );
    };

    $ctrl.addPermissionForm = function (role) {
        $uibModal
            .open({
                component: 'rolesAndPermissions',
                resolve: {
                    role: function () {
                        return role;
                    },
                    permissions: function () {
                        return $ctrl.permissions;
                    }
                }
            })
            .result
            .then(
                function (result) {

                }
            );
    };


    $ctrl.deleteRole = function (role, index) {

        if (role.deleteLoading) {
            return;
        }

        if (!confirm(`Удалить ${role.label} ?`)) {
            return;
        }

        role.deleteLoading = true;

        $http.delete(`/admin/roles/${role.id}`).then(
            function (response) {
                $ctrl.roles.splice(index, 1);
                Notifier.success('Роль успешно удален', 2);
            },
            function () {
                role.deleteLoading = false;
                Notifier.error('Произошла ошибка', 2);
            }
        );
    }

}
